import type { Template, TemplateVariants } from '../entities/Template'
import { useTemplateStore } from '../stores/useTemplateStore'
import { useUserStore } from '~~/modules/auth/stores/userStore'

export type useTemplateDataComposableParamsType = TemplateVariants

export const useTemplateDataComposable = async (
  params: useTemplateDataComposableParamsType,
) => {
  const useTemplateStoreInstance = useTemplateStore()
  const userStore = useUserStore()
  const unsubscribe = watch(
    () => userStore.state.value.logged,
    () => {
      init()
    },
  )
  onUnmounted(() => {
    unsubscribe()
  })

  const init = function () {
    useTemplateStoreInstance.setHeaderShowPopover(userStore.getLogged.value)
  }

  onMounted(() => {
    init()
  })

  const contentCall = async (): Promise<Template> => {
    const contentConstant = await import(`../constants/${params.template}.ts`)

    const contentQueryContent: Template = contentConstant.default

    return contentQueryContent
  }

  const data = await contentCall()
  const parsedData: Template = data
  useTemplateStoreInstance.setTemplate(parsedData)
}
